// Chakra Imports
import {
    Box,
    Button,
    Flex,
    Grid,
    Icon,
    Spacer,
    Text,
    Switch,
    ButtonGroup,
    FormControl,
    RadioGroup,
    FormLabel,
    IconButton,
    Input,
    Link,
    useColorMode,
    useColorModeValue,
    useDisclosure,
    Modal,
    ModalBody,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalFooter,
    Radio,
    FormHelperText,
    HStack,

} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";

import React, { useState, useEffect } from "react";
import { HSeparator } from "components/Separator/Separator";
import { RiPlantLine } from "react-icons/ri";


export default function Feed(props) {
    const { title, list, setFeedData, defaultData, ...rest } = props;
    const iconBlue = useColorModeValue("gray.100", "gray.600");
    const { colorMode } = useColorMode();
    const [inputFields, setInputFields] = useState(defaultData)
    const [titleInput, setTitleInput] = useState(title)
    const [reload, setReload] = useState(false)
    const handleFormChange = (index, event) => {
        let data = [...inputFields];
        data[index][event.target.name] = event.target.value;
        setInputFields(data);
        setFeedData({
            title: titleInput, list: data
        })
    }
    const removeFields = (index) => {
        let data = [...inputFields];
        data.splice(index, 1)
        setInputFields(data);
        let t = title
        if (data.length == 0)
            t = ""
        setFeedData({
            title: t, list: data
        })
        setReload(!reload)
    }
    const addFields = () => {
        let newfield = { quotation: "", text: "", href: '#' }
        setInputFields([...inputFields, newfield])
        setReload(!reload)
    }
    const handleTitleChange = (event) => {
        let title = event.target.value
        let data = [...inputFields];
        setTitleInput(title)
        setFeedData({
            title: title, list: data
        })
    }
    useEffect(() => {
        let data = [...inputFields];
        setFeedData({
            title: titleInput, list: data
        })
    }, [reload])
    return (
        <Grid ml={"5px"} mb={"10px"}>
            {(inputFields.length > 0 ?
                <>
                    <FormControl w='100%' mb="30px" ml="5x" id="feed-title">
                        <FormLabel fontSize="xs" >عنوان کلی</FormLabel>
                        <Input fontSize="xs" placeholder="عنوان را وارد کنید." value={titleInput} onChange={e => handleTitleChange(event)} />
                    </FormControl>
                    <HSeparator mb={"15px"} bg={colorMode === "dark" ? "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #303742 49.52%, rgba(224, 225, 226, 0) 100%)" : "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #eee 49.52%, rgba(224, 225, 226, 0) 100%)"}></HSeparator>

                    {inputFields.map((input, index) => {
                        return (
                            <div key={index} >
                                {(index != 0) ?
                                    (
                                        <HSeparator mt={"35px"} bg={colorMode === "dark" ? "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #303742 49.52%, rgba(224, 225, 226, 0) 100%)" : "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #eee 49.52%, rgba(224, 225, 226, 0) 100%)"}></HSeparator>
                                    ) : <></>
                                }

                                <FormControl w='100%' mt={"30px"} id="text">
                                    <FormLabel fontSize="xs" >متن {"#" + (index + 1)}</FormLabel>
                                    <Input name='text' fontSize="xs" placeholder="متن را وارد کنید." value={input.text} onChange={event => handleFormChange(index, event)} />
                                </FormControl>
                                <Grid mt={"20px"} templateColumns={{ sm: "1fr", lg: "2fr 2fr" }} templateRows='1fr'>
                                    <Flex>
                                        <FormControl w='100%' id="quotation">
                                            <FormLabel fontSize="xs" >موضوع {"#" + (index + 1)}</FormLabel>
                                            <Input name='quotation' fontSize="xs" placeholder="موضوع را وارد کنید." value={input.quotation} onChange={event => handleFormChange(index, event)} />
                                        </FormControl>
                                    </Flex>
                                    <Flex>
                                        <FormControl mr={{ sm: "0px", md: "5px" }} mt={{ sm: "20px", md: "0px" }} w='100%' id="href">
                                            <FormLabel fontSize="xs">آدرس {"#" + (index + 1)}</FormLabel>
                                            <Input name='href' dir="ltr" fontSize="xs" placeholder="" value={input.href} onChange={event => handleFormChange(index, event)} />
                                        </FormControl>
                                    </Flex>
                                </Grid>
                                <Grid>
                                <Flex>
                                    <Button  mt={"10px"} fontSize='xs' onClick={() => removeFields(index)} >حذف رکورد</Button>
                    </Flex>
                                </Grid>

                            </div>
                        )
                    })}
                    <Grid textAlign={"center"}>
                        <Button onClick={addFields} mt={"30px"} mr="auto" ml="auto" fontSize='xs' >افزودن رکورد جدید</Button>
                    </Grid>
                </>
                :
                <div>
                    <Flex mt="50px" align='center' w='100%'>
                        <IconBox as='box' w={"100%"} >
                            <Icon h={"150px"} w={"150px"} color={iconBlue} as={RiPlantLine} />
                        </IconBox>

                    </Flex>
                    <Flex align='center' w='100%'>
                        <Button onClick={addFields} mt={"30px"} mr="auto" ml="auto" fontSize='xs' >افزودن خبر فوری</Button>
                    </Flex>
                </div>
            )}
        </Grid>

    );
}
